import aclName from '../../../../../acl/AclName';
import action from '../../../../abstract/action';

export default action({
  main: () => true,
  label: 'Edytuj',
  icon: 'EditIcon',
  render: ({ item, aclHave }) => {
    if (!item?.is_base) {
      return true;
    }

    if (aclHave(aclName.SettingsPageBasePriceListsEdit)) {
      return true;
    }

    return false;
  },

  handle: async ({ $router, item }) => await $router.push({
    name: 'admin-price-lists-list', params: { id: item.id },
  }),
});
